/* eslint-disable require-jsdoc */
import { AxiosStatic } from 'axios';

export default class CallService2 {
    axios;

    constructor(axios: AxiosStatic) {
        this.axios = axios;
    }

    async createUserCall(contact, sendEmail, timeZone) {
        return this.axios.post('/v2/call/user', { contact,
            sendEmail,
            timeZone });
    }
    async createMultipleUserCall(groupIds, contactIds, timeZone) {
        return this.axios.post('/v2/call/multiple_user', {
            groupIds,
            contactIds,
            timeZone
        });
    }
    async createCallFromHistory(historyId, timeZone) {
        return this.axios.post('/v2/call/from_hitory', { historyId,
            timeZone });
    }

    async createUserCallByPhone(phoneNumber) {
        return this.axios.post('/v2/call/user', { phoneNumber });
    }

    async createGroupCall(groupId, data) {
        return this.axios.post(`/v2/call/group/${groupId}`, data);
    }
    async addGroupCall(room, groupId, timeZone) {
        return this.axios.post('/v2/call/add/group', {
            room,
            groupId,
            timeZone
        });
    }

    async addUserFromContactIntoCall(roomId, userId, sendEmail, timeZone) {
        return this.axios.post('/v2/call/add/user', { roomId,
            userId,
            sendEmail,
            timeZone });
    }
    async addMultipleUserFromContactIntoCall(roomId, contacts, groups, timeZone) {
        return this.axios.post('/v2/call/add/multiple_users', { roomId,
            contacts,
            groups,
            timeZone
        });
    }
    async addUserFromNumberIntoCall(roomId, phoneNumber) {
        return this.axios.post('/v2/call/add/user', { roomId,
            phoneNumber });
    }

    async joinCall(id) {
        this.axios.post(`/v2/call/${id}/join`);
    }

    async rejectCall(id) {
        this.axios.post(`/v2/call/${id}/reject`);
    }

    async endCall(id) {
        this.axios.post(`/v2/call/${id}/end`);
    }
}
